<template>
  <el-dialog
    :visible.sync="visible"
    :title="title"
    width="80%"
    top="5vh"
    custom-class="video-player-dialog"
    @close="handleClose"
  >
    <div class="video-player-container">
      <video
        ref="videoPlayer"
        class="video-js vjs-big-play-centered"
        controls
        autoplay
        preload="auto"
      >
        <source :src="videoUrl" :type="videoType" />
        您的浏览器不支持视频播放
      </video>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'VideoPlayer',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    videoUrl: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: '视频播放'
    }
  },
  data() {
    return {
      player: null
    }
  },
  computed: {
    videoType() {
      const url = this.videoUrl.toLowerCase()
      if (url.endsWith('.mp4')) return 'video/mp4'
      if (url.endsWith('.webm')) return 'video/webm'
      if (url.endsWith('.ogg')) return 'video/ogg'
      if (url.endsWith('.mov')) return 'video/quicktime'
      if (url.endsWith('.avi')) return 'video/x-msvideo'
      if (url.endsWith('.mkv')) return 'video/x-matroska'
      if (url.endsWith('.flv')) return 'video/x-flv'
      if (url.endsWith('.m3u8')) return 'application/x-mpegURL'
      return 'video/mp4'
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.$nextTick(() => {
          this.initPlayer()
        })
      } else {
        this.destroyPlayer()
      }
    }
  },
  methods: {
    initPlayer() {
      if (this.player) {
        this.player.src({ src: this.videoUrl, type: this.videoType })
        return
      }

      const videoElement = this.$refs.videoPlayer
      if (!videoElement) return

      // 使用原生 HTML5 video，无需额外库
      videoElement.load()
    },
    destroyPlayer() {
      const videoElement = this.$refs.videoPlayer
      if (videoElement) {
        videoElement.pause()
        videoElement.currentTime = 0
      }
    },
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    }
  },
  beforeDestroy() {
    this.destroyPlayer()
  }
}
</script>

<style lang="scss">
.video-player-dialog {
  .el-dialog__body {
    padding: 20px;
    background: #000;
  }
}

.video-player-container {
  width: 100%;
  background: #000;
  
  video {
    width: 100%;
    height: auto;
    max-height: 70vh;
    outline: none;
  }
}
</style>
